// 封装所以和用户相关的接口函数
import request from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";


//发送验证码
export const sendCodeAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/sendCode`,
        method: 'POST',
        data
    })
}
//登录
export const loginAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/login`,
        method: 'POST',
        data
    })
}
//登录Google
export const loginGoogleAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/google_login`,
        method: 'POST',
        data
    })
}

//登录Telegram
export const loginTelegramAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/telegram_login`,
        method: 'POST',
        data
    })
}

//获取手机区号

export const areaCodeAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/areaCode`,
        method: 'GET',
       
    })
}
//注册
export const registerAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/register`,
        method: 'POST',
        data
    })
}
//忘记密码
export const setPwdAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/changePwd`,
        method: 'POST',
        data
    })
}
//获取用户数据
export const userAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/user/detail`,
        method: 'get',
    })
}
//获取收藏列表
export const collectionListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/collection/list`,
        method: 'get',
        params
    })
}
//获取收藏列表
export const followListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/follow/list`,
        method: 'get',
        params
    })
}

//获取收藏列表
export const fansListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/fans/list`,
        method: 'get',
        params
    })
}
//添加地址


export const addAddressAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/create_address`,
        method: 'POST',
        data
    })
}
/**
 * 删除地址
 * @param {} data 
 * @returns 
 */
export const delAddressAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/del_address`,
        method: 'POST',
        data
    })
}
//修改地址
export const editAddressAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/modify_address`,
        method: 'POST',
        data
    })
}

//获取地址列表
export const addressListAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/address_list`,
        method: 'get',
    })
}
//获取地址详情
export const getAddressInfoAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/address_info`,
        method: 'get',
        params
    })
}
//设置默认地址
export const setDefaultaddressAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/modify_default_address`,
        method: 'POST',
        data
    })
}
// 获取喜欢列表API
export const getLikeListAPI = ({ limit = 4 }) => {
    return request({
        url: '/goods/relevant',
        params: {
            limit
        }
    })
}

//设置默认地址
export const setUserAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/user/update`,
        method: 'POST',
        data
    })
}
/**
 * 修改用户头像
 * @param {*} data 
 * @returns 
 */
export const setAvatarAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/upload/avatar`,
        method: 'POST',
        data
    })
}
/**
 * 获取历史记录
 * @param {} params 
 * @returns 
 */
export const getbrowseListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/browse/list`,
        method: 'get',
        params
    })
}
/**
 * 通知消息
 * @param {} params 
 * @returns 
 */
export const getMessageListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/message_list`,
        method: 'get',
        params
    })
}
/**设置消息 */

export const setReadAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/read`,
        method: 'POST',
        data
    })
}

//获取其他用户详情
export const getSpaceDetailAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/space/detail`,
        method: 'get',
        params
    })
}


export const getSpaceListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/space/product/list`,
        method: 'get',
        params
    })
}

/**
 * 退出登录
 * @param {} data 
 * @returns 
 */
export const setLogoutAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/logout`,
        method: 'POST',
        data
    })
}

export const getCountryProvincesAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/area/country_provinces`,
        method: 'get',
    })
}
export const getPromoterAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/promoter/info`,
        method: 'post',
    })
}
/**
 * 获取ip地址
 */

export const getIpAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/getIp`,
        method: 'get',
    })
}
/**
 * 获取客服
 */

export const getKefuAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/kefu`,
        method: 'get',
    })
}
/**
 * 获取汇率
 */
export const getExchangeRateAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/exchangeRate`,
        method: 'GET',
      
    })
}
/**
 * 推荐人成员列表
 */
export const getMemberListAPI = (param) => {
    return request({
        url: `${AUTH_BASE_URL}/promoter/member_list`,
        method: 'GET',
        param
    })
}

/**
 * 获取联系方式
 */
export const getContactDetailsAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/setting/list`,
        method: 'GET',
      
    })
}
/**
 * 订阅
 * @param {} data 
 * @returns 
 */
export const addSubscribeAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/subscribe/add`,
        method: 'POST',
        data
      
    })
}

export const getcountryCodeAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/countryCode/list`,
        method: 'GET',
      
    })
}
//steady订单用户信息存储
export const addStoreOrderSteadyAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/store_order_steady`,
        method: 'POST',
        data
      
    })
}
//获取订单数
export const getOrder_countAPI = () => {
    return request({
        url: `${AUTH_BASE_URL}/order_count`,
        method: 'GET',
      
    })
}
